import { createAsyncThunk } from '@reduxjs/toolkit';
import islamicApplicationService from './islamicApplicationService';
import { restructureErrorMessage } from '../../helpers/errorMessage';
import fileService from '../fileService/fileService';

export const getIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSubmitForApprovalIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getSubmitForApprovalList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getSubmitForApprovalIslamicApplication(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPendingIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getPendingApplicationList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getPendingIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getReferbackIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getReferbackApplicationList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getReferbackIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getReferbackFromPendingDisbursementIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getReferbackFromPendingDisbursementApplicationList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getReferbackFromPendingDisbursementIslamicApplications(
        requestData
      );
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getFollowUpIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getFollowUpApplicationList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getFollowUpIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getApprovedIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getApprovedApplicationsList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getApprovedIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getRejectedIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getRejectedApplicationList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getRejectedIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCancelledIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getCancelledApplicationList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getCancelledIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getDraftIslamicApplicationsThunk = createAsyncThunk(
  'islamicApplication/getDraftApplications',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getDraftIslamicApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicApplicationDetailsThunk = createAsyncThunk(
  'islamicApplication/getDetails',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicApplicationDetails(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicInternalRemarksByApplicationIDThunk = createAsyncThunk(
  'islamicApplication/getInternalRemarks',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicInternalRemarksByApplicationID(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicHistoryLogsByApplicationIDThunk = createAsyncThunk(
  'islamicApplication/getHistoryLogs',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicHistoryLogsByApplicationID(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicHistoryLogsByApplicationIDAndAgreementIDThunk = createAsyncThunk(
  'islamicApplication/getHistoryLogs/combine',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicHistoryLogsByApplicationIDAndAgreementID(
        requestData
      );
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicApplicantFilesThunk = createAsyncThunk(
  'islamicApplication/getApplicantFiles',
  async (requestData: any, thunkAPI) => {
    try {
      return await fileService.getFilesByEntityId(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createIslamicInternalRemarkThunk = createAsyncThunk(
  'islamicApplication/createInternalRemark',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.createIslamicInternalRemark(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const referBackIslamicApplicationThunk = createAsyncThunk(
  'islamicApplication/referBack',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.referBackIslamicApplication(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const referBackIslamicApplicationFromPendingDisbursementThunk = createAsyncThunk(
  'islamicApplication/referBackFromPendingDisbursement',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.referBackIslamicApplicationFromPendingDisbursement(
        requestData
      );
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIslamicApplicationStatusToFollowedUpThunk = createAsyncThunk(
  'islamicApplication/updateStatusToFollowedUp',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.updateIslamicApplicationStatusToFollowedUp(
        requestData
      );
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIslamicApplicationStatusToCaseSettledFromFollowedUpThunk = createAsyncThunk(
  'islamicApplication/updateStatusToCaseSettledFromFollowedUp',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.updateIslamicApplicationStatusToCaseSettledFromFollowedUp(
        requestData
      );
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIslamicApplicantUserDetailsThunk = createAsyncThunk(
  'islamicApplication/updateApplicantUserDetails',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.updateIslamicApplicantUserDetails(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const cancelIslamicApplicationThunk = createAsyncThunk(
  'islamicApplication/cancel',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.cancelIslamicApplication(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const submitForIslamicApprovalThunk = createAsyncThunk(
  'islamicApplication/submitForApproval',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.submitForIslamicApproval(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const approveIslamicApplicationThunk = createAsyncThunk(
  'islamicApplication/approve',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.approveIslamicApplication(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const rejectIslamicApplicationThunk = createAsyncThunk(
  'islamicApplication/reject',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.rejectIslamicApplication(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteIslamicApplicationThunk = createAsyncThunk(
  'islamicApplication/delete',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.deleteIslamicApplication(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicApplicationCreditRecordThunk = createAsyncThunk(
  'islamicApplication/credit-record',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicApplicationCreditRecord(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIslamicApplicationFinanceAmountThunk = createAsyncThunk(
  'islamicApplication/updateFinanceAmount',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.updateIslamicApplicationFinanceAmount(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIslamicApplicantThunk = createAsyncThunk(
  'islamicApplication/updateApplicant',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.updateIslamicApplicant(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateIslamicApplicationNetIncomeThunk = createAsyncThunk(
  'islamicApplication/updateApplicationNetIncome',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.updateIslamicApplicationNetIncome(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const islamicGlobalSearchThunk = createAsyncThunk(
  'islamicApplication/globalSearch',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.islamicGlobalSearch(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicApplicationExperianReportThunk = createAsyncThunk(
  'islamicApplication/getApplicationExperianReport',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicApplicationExperianReport(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const regenerateIslamicApplicationFormThunk = createAsyncThunk(
  'islamicApplication/regenerateApplicationForm',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.regenerateIslamicApplicationForm(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const onReRunIslamicApplicationCreditEvaluationThunk = createAsyncThunk(
  'islamicApplication/re-run-application-credit-evaluation-engine',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.reRunIslamicApplicationCreditEvaluationEngine(
        requestData
      );
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getIslamicApprovedReviewApplicationsThunk = createAsyncThunk(
  'islamicApplication/getApprovedReviewApplicationsList',
  async (requestData: any, thunkAPI) => {
    try {
      return await islamicApplicationService.getIslamicApprovedReviewApplications(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
